interface FeedbackSubmission {
    message: string;
    language: string;
    user_agent: string;
    url: string;
  }
  
  interface FeedbackResponse {
    success: boolean;
    message: string;
  }
  
  class FeedbackApiService {
    private baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8001';
    
    async submitFeedback(feedback: FeedbackSubmission): Promise<FeedbackResponse> {
      const response = await fetch(`${this.baseUrl}/api/v1/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedback),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      return response.json();
    }
  
    async checkHealth(): Promise<boolean> {
      try {
        const response = await fetch(`${this.baseUrl}/api/v1/feedback/health`);
        return response.ok;
      } catch {
        return false;
      }
    }
  }
  
  export const feedbackApi = new FeedbackApiService();